export default __webpack_public_path__ + "static/media/milestone 3400.4563a0ae.svg";